module.exports = __webpack_public_path__ + "static/media/jt4.e2603aae.png";